import { big } from './big-utils'

export const bigInt = (value?: string | number | bigint | null) => {
  if (!value || value === null) return 0n
  try {
    return BigInt(value)
  } catch {
    return 0n
  }
}

export function safeDivBigInt(numerator: bigint, denominator: bigint): bigint {
  if (denominator === 0n) {
    console.warn('Division by zero attempted. Returning 0n as fallback.')
    return 0n
  }
  return numerator / denominator
}

export function bigIntToBig(value: bigint | string) {
  return big(value.toString())
}

export function fullMulDiv(x: bigint, y: bigint, z: bigint) {
  return safeDivBigInt(x * y, z)
}
